import type {
	PortalIssueDetailDto,
	PortalIssueListResponseDto,
	PortalIssueReplyRequestDto,
	PortalIssueReplyResponseDto,
	PortalSubmitIssueRequestDto,
	PortalSubmitIssueResponseDto,
} from '@supply-mover-2-0/shared';
import { portalFetch } from '../lib/apiClient';

/**
 * Submit a support issue from the storefront (PD-13705). Login required —
 * the API links the issue to the customer's active client.
 */
export async function submitPortalIssue(
	token: string,
	payload: PortalSubmitIssueRequestDto,
): Promise<PortalSubmitIssueResponseDto> {
	return portalFetch<PortalSubmitIssueResponseDto>('/issues', token, {
		method: 'POST',
		body: JSON.stringify(payload),
	});
}

/**
 * The customer's own submitted issues (PD-13773) — the API scopes the
 * list strictly to issues the signed-in portal user created.
 */
export async function listPortalIssues(
	token: string,
): Promise<PortalIssueListResponseDto> {
	return portalFetch<PortalIssueListResponseDto>('/issues', token);
}

/** Issue detail + communication thread (PD-13773). */
export async function getPortalIssue(
	token: string,
	issueId: number,
): Promise<PortalIssueDetailDto> {
	return portalFetch<PortalIssueDetailDto>(`/issues/${issueId}`, token);
}

/** Append a customer reply to the thread (PD-13773). */
export async function replyToPortalIssue(
	token: string,
	issueId: number,
	payload: PortalIssueReplyRequestDto,
): Promise<PortalIssueReplyResponseDto> {
	return portalFetch<PortalIssueReplyResponseDto>(
		`/issues/${issueId}/messages`,
		token,
		{
			method: 'POST',
			body: JSON.stringify(payload),
		},
	);
}
